export function formatDollars(v) {
  return `$${v < 0 ? "-" : ""}${Math.abs(v).toFixed(2)}`;
}
